import React from 'react'
import * as S from './styled'

export const PdfViewer: React.VFC<{ path: string }> = ({ path }) => (
  <S.FormattedEmbed src={path} type={'application/pdf'} />
)
